import { Model, attr } from '@elatonsev/js-models';

export default class ClientModel extends Model {
  name = attr('string');
  phone = attr('string');
  email = attr('string');
}